import { Link } from "react-router-dom";

export default function LegalPage({ title, children }) {
  return (
    <div className="min-h-screen">
      <header className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
        <Link to="/" className="font-heading text-xl font-semibold tracking-tight">
          auto<span className="text-[#0055FF]">.</span>advisor
        </Link>
        <Link to="/" className="text-sm text-[#666] hover:text-[#111]">← Torna alla home</Link>
      </header>
      <main className="max-w-3xl mx-auto px-6 pt-6 pb-24">
        <h1 className="font-heading text-4xl font-semibold tracking-tight" data-testid="legal-title">{title}</h1>
        <div className="mt-10 prose prose-neutral max-w-none text-[15px] leading-relaxed text-[#333] space-y-4">
          {children}
        </div>
      </main>
    </div>
  );
}

export function PrivacyPage() {
  return (
    <LegalPage title="Informativa Privacy">
      <p className="text-sm text-[#666]">Ultimo aggiornamento: Febbraio 2026 · Ai sensi degli artt. 13-14 del Reg. UE 2016/679 (GDPR).</p>

      <h2 className="font-heading text-2xl font-semibold mt-8">1. Titolare del trattamento</h2>
      <p>Il Titolare del trattamento è <b>auto.advisor</b> (in seguito il "Titolare"). Per esercitare i tuoi diritti scrivi a: <a href="mailto:privacy@auto-advisor.app" className="text-[#0055FF] underline">privacy@auto-advisor.app</a>.</p>

      <h2 className="font-heading text-2xl font-semibold mt-8">2. Dati raccolti</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li><b>Dati di navigazione</b> forniti al wizard (uso, km, città, budget, ecc.) — non identificativi da soli.</li>
        <li><b>Account</b> (se ti registri): email, nome, password cifrata (bcrypt) oppure identità Google (email, nome, foto profilo).</li>
        <li><b>Lead</b> (se compili il modulo contatto): nome, email, telefono, consensi.</li>
        <li><b>Cookie tecnici</b> di sessione (`session_token`, httpOnly, 7 giorni) e una preferenza consenso.</li>
      </ul>

      <h2 className="font-heading text-2xl font-semibold mt-8">3. Finalità e base giuridica</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li><b>Fornitura del servizio</b> (art. 6.1.b) — generazione raccomandazioni, gestione account, storico ricerche.</li>
        <li><b>Marketing diretto</b> (art. 6.1.a) — solo previo consenso esplicito nel modulo lead.</li>
        <li><b>Cessione a terzi</b> (concessionari partner, art. 6.1.a) — solo previo secondo consenso esplicito.</li>
        <li><b>Obblighi di legge</b> (art. 6.1.c) — conservazione documentale fiscale/amministrativa.</li>
      </ul>

      <h2 className="font-heading text-2xl font-semibold mt-8">4. Destinatari</h2>
      <p>I dati possono essere condivisi con: (a) fornitori tecnici (hosting cloud, database MongoDB, servizio email Resend Inc. — USA con clausole SCC); (b) Google (solo per utenti Google Login); (c) <b>concessionari e rivenditori auto partner</b> — solo se hai prestato consenso alla cessione.</p>

      <h2 className="font-heading text-2xl font-semibold mt-8">5. Conservazione</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>Account: fino a cancellazione da parte tua.</li>
        <li>Lead con consenso: 24 mesi dall'ultimo contatto utile, salvo revoca.</li>
        <li>Log tecnici: 12 mesi.</li>
      </ul>

      <h2 className="font-heading text-2xl font-semibold mt-8">6. Diritti dell'interessato</h2>
      <p>Puoi in qualsiasi momento esercitare i diritti di accesso, rettifica, cancellazione, limitazione, opposizione, portabilità e revoca del consenso (artt. 15-22 GDPR) scrivendo a <a href="mailto:privacy@auto-advisor.app" className="text-[#0055FF] underline">privacy@auto-advisor.app</a>. Hai inoltre diritto di proporre reclamo al Garante privacy (garanteprivacy.it).</p>

      <h2 className="font-heading text-2xl font-semibold mt-8">7. Trasferimenti extra-UE</h2>
      <p>Alcuni fornitori (Resend, Google) possono trattare dati fuori dall'UE. Il trasferimento avviene sulla base delle Standard Contractual Clauses della Commissione UE.</p>

      <h2 className="font-heading text-2xl font-semibold mt-8">8. Sicurezza</h2>
      <p>Password cifrate con bcrypt, sessioni con cookie httpOnly/secure/samesite=none, token di reset SHA-256 hashati monouso (30 min), TLS end-to-end.</p>
    </LegalPage>
  );
}

export function CookiePage() {
  return (
    <LegalPage title="Cookie Policy">
      <p>Questa pagina descrive i cookie utilizzati da <b>auto.advisor</b>.</p>

      <h2 className="font-heading text-2xl font-semibold mt-8">Cookie tecnici (sempre attivi)</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li><code>session_token</code> — mantiene la tua sessione di accesso. Durata 7 giorni. HttpOnly, Secure.</li>
        <li><code>aa_cookie_consent_v1</code> — memorizza la tua scelta sul banner cookie. LocalStorage.</li>
      </ul>

      <h2 className="font-heading text-2xl font-semibold mt-8">Cookie di profilazione</h2>
      <p>Non utilizziamo cookie di profilazione né pixel di terze parti.</p>

      <h2 className="font-heading text-2xl font-semibold mt-8">Come gestire i cookie</h2>
      <p>Puoi eliminare i cookie in qualsiasi momento dalle impostazioni del browser. Rifiutando i cookie tecnici essenziali il servizio potrebbe non funzionare correttamente.</p>
    </LegalPage>
  );
}
